import './ScrollableBlock.css';

function ScrollableBlock({children}) {

    return (
        <div className="about-page__slide" >
            {children}
        </div>
    );
}

export default ScrollableBlock